module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNyIgaGVpZ2h0PSI1IiB2aWV3Qm94PSIwIDAgNyA1IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPg0KPHBhdGggZD0iTTAgMC45NjAzMjhDMCAwLjU1NTgxNiAwLjQ1NTM0MiAwLjMxODc0IDAuNzg2NzMxIDAuNTUwNzEyTDQuNDE0ODMgMy4wOTAzOEM0LjY5OTE5IDMuMjg5NDMgNC42OTkxOSAzLjcxMDU3IDQuNDE0ODMgMy45MDk2MkwwLjc4NjczMSA2LjQ0OTI5QzAuNDU1MzQzIDYuNjgxMjYgMCA2LjQ0NDE4IDAgNi4wMzk2N1YwLjk2MDMyOFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgNSkgcm90YXRlKC05MCkiIGZpbGw9IiMyOTk3NGIiLz4NCjwvc3ZnPg0K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/rectangle-green.svg
// module id = vopK
// module chunks = 13